import { RebalanceOptions } from '@/types/enums/sleeve-management'

// Normalizes the loose `model_assignment.rebalance_strategy` string (which can
// also be 'unspecified' or empty) into a RebalanceOptions. Anything that isn't
// an explicit rebalancing choice defaults to Never — builder sleeves don't
// rebalance (or sell) until a user opts in.
export function toRebalanceOptions(
  value: string | undefined,
): RebalanceOptions {
  switch (value) {
    case RebalanceOptions.Enabled:
      return RebalanceOptions.Enabled
    case RebalanceOptions.ViolationsOnly:
      return RebalanceOptions.ViolationsOnly
    default:
      return RebalanceOptions.Never
  }
}
